<template>
  <v-container fluid class="px-12 py-2">
    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col cols="6"
            ><breadcrumbs></breadcrumbs>
            <h1>Primary Roles</h1></v-col
          >
          <v-col cols="6" class="text-right"
            ><v-btn
              @click="navigate(null)"
              color="primary"
              outlined
              class="mt-5"
              >Add</v-btn
            ></v-col
          >
        </v-row>

        <v-text-field
          label="Filter"
          v-model="search"
          outlined
          class="mt-5"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          class="och-table"
          sort-by="name"
        >
          <template v-slot:item="{ item }">
            <tr @click="navigate(item.id)" class="och-tableRow">
              <td>
                {{ item.name }}
              </td>
              <td>
                {{ item.description }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Breadcrumbs from "../Breadcrumbs";

export default {
  components: {
    Breadcrumbs,
  },
  computed: {
    ...mapState({
      list: state => state.secRolePrimary.list,
    }),
  },
  async created() {
    await this.getList();
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Description",
          value: "description",
          align: "start",
        },
      ],
      search: null,
    };
  },
  methods: {
    navigate(primaryRoleId) {
      if (primaryRoleId) {
        this.$router.push({
          name: "ochinUserSecurityPrimaryRoleForm",
          params: { primaryRoleId },
        });
        return;
      }

      this.$router.push({
        name: "ochinUserSecurityPrimaryRoleFormCreate",
      });
    },
    ...mapActions({
      getList: "secRolePrimary/list",
    }),
  },
};
</script>
